import React, { Component } from "react";
import { Link } from "react-router-dom";
import breadcrumb from "../../data/breadcrumb.json";

const preparedNavlist = (currentPath) => {
  const pathList = currentPath.split("/");
  if (pathList[pathList.length - 1] === "") {
    pathList.splice(-1);
  }
  const list = pathList.map((item) => {
    return breadcrumb.filter((subItem) => subItem.id === item)[0];
  });
  return list;
};

class Breadcrumbs extends Component {
  render() {
    const navList =
      this.props.breadcrumb.pagename === "Error 404"
        ? [{ label: "Error 404", description: "Seems you are lost!" }]
        : preparedNavlist(this.props.currentPath);
    return (
      <div className="breadcrumbBanner" style={{}}>
        <div className="breadcrumb">
          <div className="navListContainer">
            <ol
              style={{
                color: "black",
                listStyleType: "none",
                display: "flex",
                gap: "10px",
                margin: "0",
                alignItems: "center",
              }}
            >
              {navList.map((item, index) => {
                return (
                  <li key={index}>
                    <Link
                      to={item.path}
                      className={
                        index + 1 === navList.length
                          ? "breadcrumb__link breadcumb__currentPage"
                          : "breadcrumb__link breadcumb__nonCurrentPage"
                      }
                    >
                      {item.label}
                    </Link>
                    {index + 1 !== navList.length && (
                      <svg
                        width="7"
                        height="11"
                        viewBox="0 0 7 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.23648 0.792582C1.14355 0.885448 1.06984 0.995716 1.01954 1.11708C0.969246 1.23845 0.943359 1.36854 0.943359 1.49992C0.943359 1.63129 0.969246 1.76138 1.01954 1.88275C1.06984 2.00411 1.14355 2.11438 1.23648 2.20725L4.29315 5.26458C4.35564 5.32709 4.39074 5.41186 4.39074 5.50025C4.39074 5.58864 4.35564 5.67341 4.29315 5.73592L1.23648 8.79258C1.04888 8.98009 0.943457 9.23444 0.943394 9.49968C0.943332 9.76492 1.04864 10.0193 1.23615 10.2069C1.42365 10.3945 1.678 10.4999 1.94324 10.5C2.20848 10.5001 2.46288 10.3948 2.65048 10.2072L5.70781 7.14992C5.92451 6.93324 6.0964 6.67601 6.21368 6.3929C6.33095 6.10979 6.39131 5.80635 6.39131 5.49991C6.39131 5.19348 6.33095 4.89004 6.21368 4.60693C6.0964 4.32382 5.92451 4.06659 5.70781 3.84991L2.65048 0.792581C2.46295 0.60511 2.20864 0.499796 1.94348 0.499796C1.67831 0.499796 1.42401 0.60511 1.23648 0.792582Z"
                          fill="#A3A3A3"
                        />
                      </svg>
                    )}
                  </li>
                );
              })}
            </ol>
          </div>
        </div>

        <div className="breadcrumbPageInfo">
          <h1>{navList[navList.length - 1].label}</h1>
          <p>{navList[navList.length - 1].description}</p>
        </div>

        <img
          src={
            process.env.PUBLIC_URL + "/assets/mission health/SubPagesBanner.jpg"
          }
          alt="subheader"
          className="breadcrumbImage"
        />
      </div>
    );
  }
}

export default Breadcrumbs;
